import styles from "./remoteConfig.module.css";
import PropTypes from "prop-types";
import moment from "moment";
import useHover from "../../hooks/useHover";
import DateToolTip from "../DateToolTip/DateToolTip";
import { useIntl } from "react-intl";

const FieldItem = ({ label, defaultLabel, value, fullWidth = false, isLink = false, isDate = false }) => {
  const intl = useIntl();
  const { handleMouseEnter, handleMouseLeave, hoveredData, ishovered } =
    useHover();
  const itemClassName = `${styles.item} ${fullWidth ? styles.itemFull : ""}`;

  const renderFieldValue = () => {
    if (!value) {
      return <span className={styles.value}>N/A</span>;
    }

    if (isLink) {
      const fullUrl = `${import.meta.env.VITE_DOMAIN}${value}`;

      return (
        <a
          href={fullUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.anchorLink}
        >
          {fullUrl}
        </a>
      );
    }

    if (isDate) {
      const formattedDate = moment.utc(value).local().format("DD.MM.YYYY HH:mm");

      return (
        <button
          onMouseEnter={() => handleMouseEnter(value)}
          onMouseLeave={handleMouseLeave}
          className={styles["unstyled-button"]}
        >
          <span className="pe-1">{formattedDate}</span>
          <DateToolTip ishovered={ishovered} hoveredData={hoveredData} />
        </button>
      );
    }

    return <span className={styles.value}>{value}</span>;
  };


  return (
    <div className={itemClassName}>
      <b className={styles.label}>{intl.formatMessage({
        id: label,
        defaultMessage: defaultLabel,
      })}</b>
      {renderFieldValue()}
    </div>
  );
};

FieldItem.propTypes = {
  label: PropTypes.string.isRequired,
  defaultLabel: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullWidth: PropTypes.bool,
  isLink: PropTypes.bool,
  isDate: PropTypes.bool,
};

const RemoteConfig = ({ ConfigInfoData }) => {
  const remoteConfig = ConfigInfoData?.remote_consent_config;

  return (
    <div className={styles.container}>
      <FieldItem
        label="config.remote-config.document-version-number"
        defaultLabel="Document Version Number"
        value={remoteConfig?.document_version_number}
      />
      <FieldItem
        label="config.remote-config.remote" defaultLabel="Remote" value={remoteConfig?.remote} />
      <FieldItem
        label="config.remote-config.collection-channel"
        defaultLabel="Collection Channel"
        value={remoteConfig?.collection_channel}
      />
      <FieldItem
        label="config.remote-config.statement-url"
        defaultLabel="Statement URL"
        value={remoteConfig?.statement_url}
        fullWidth
        isLink
      />
      <FieldItem
        label="config.remote-config.unsubscribe-url"
        defaultLabel="Unsubscribe URL"
        value={remoteConfig?.unsubscribe_url}
        fullWidth
        isLink
      />
      <FieldItem
        label="config.remote-config.commit-hash"
        defaultLabel="Commit Hash"
        value={remoteConfig?.commit_hash}
        fullWidth
      />
      <FieldItem
        label="config.remote-config.commit-date-time"
        defaultLabel="Commit Date Time"
        value={remoteConfig?.commit_datetime}
        fullWidth
        isDate
      />
    </div>
  );
};

RemoteConfig.propTypes = {
  ConfigInfoData: PropTypes.shape({
    remote_consent_config: PropTypes.shape({
      document_version_number: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      remote: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      collection_channel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      statement_url: PropTypes.string,
      unsubscribe_url: PropTypes.string,
      commit_hash: PropTypes.string,
      commit_datetime: PropTypes.string,
    }),
  }),
};

export default RemoteConfig;
